<template>
  <v-chip
    :small="small"
    outlined
    class="font-weight-medium px-2"
    read-only
    :ripple="false"
  >
    <div class="d-flex align-center">
      <!-- Green Light -->
      <v-icon
        :small="small"
        :color="status === 'green' ? 'success' : 'grey lighten-1'"
      >
        {{ status === "green" ? "mdi-check-circle" : "mdi-circle-outline" }}
      </v-icon>

      <!-- Yellow Light -->
      <v-icon
        :small="small"
        :color="status === 'yellow' ? 'orange' : 'grey lighten-1'"
      >
        {{ status === "yellow" ? "mdi-minus-circle" : "mdi-circle-outline" }}
      </v-icon>

      <!-- Red Light -->
      <v-icon
        :small="small"
        :color="status === 'red' ? 'error' : 'grey lighten-1'"
        class=""
      >
        {{ status === "red" ? "mdi-close-circle" : "mdi-circle-outline" }}
      </v-icon>
    </div>
  </v-chip>
</template>

<script>
export default {
  name: "performance-target-traffic-light",
  components: {},
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) =>
        ["green", "yellow", "red", "unknown"].includes(value),
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  methods: {},
};
</script>
